import React from 'react';

const BrandMark: React.FC<{ className?: string }> = ({ className }) => (
  <img src="/assets/icon/logo-64.png" alt="DomIoT" className={className} />
);

export default BrandMark;
